// @flow
import { httpClient } from 'angieslist-app-platform';
import { getCid } from '../../../app/browser/analyticsHelpers';

export const advertiseRequest = (cid: ?string = getCid()): any =>
  httpClient.post(
    '/gateway/office-home/v1/users/advertiseWithUs',
    {
      body: {
        cid,
      },
    },
  );

export const advertiseRequestByCategory =
  (serviceProviderId: string, categoryGroupId: number, contactCountDisplayed: number): any =>
    httpClient.post(
      `/gateway/office-home/v1/service_provider/${serviceProviderId}/categories/${categoryGroupId}/advertise`,
      {
        headers: {
          'X-ANGI-CallerId': serviceProviderId,
        },
        body: {
          contactCountDisplayed,
        },
      },
    );

export const contactCountByTopCategory =
(serviceProviderId: string, startTime: string, endTime: string): any =>
  httpClient.get(
    `/gateway/office-home/v1/contacts/service_provider/${serviceProviderId}/contacts-by-top-category-group?contactTypes=RequestAQuote&contactTypes=DealClaimed&contactTypes=MessageSent&contactTypes=XMLAutoMatch&startTime=${startTime}&endTime=${endTime}`,
    {
      headers: {
        'X-ANGI-CallerId': serviceProviderId,
      },
    },
  );

export default {
  advertiseRequest,
  advertiseRequestByCategory,
  contactCountByTopCategory,
};



// WEBPACK FOOTER //
// ./src/app/common/advertise/advertiseService.js